import * as madnes from "../../framework/src/engine/madnes/madnes";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {behavior_config, he, server_config} from "../../framework/src/engine/madnes/madnes_variables";
import {set_show_money_pos_y} from "../../framework/src/engine/madnes/madnes_anims";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {rof_print_desk} from "../rof_reels";
import {rof_print_reels} from "../rof_core_printer";
import {devil_wink_eye_animation, rof_rotate_run} from "../rof_core";
import {
    openinfo,
    rof_infomenu_close,
    rof_infomenu_init,
    rof_infomenu_left,
    rof_infomenu_open,
    rof_infomenu_right, rof_infomenu_update
} from "../rof_infomenu";


export const infotexts_languages = [
    "cs", "en", "fr", "hr", "ro", "pl", "de", "fi", "no", "ru", "es", "sr", "sv", "tr", "sk", "pt", "es-mx", "bg", "it"
];

export function initGame(gameset) {

    set_show_money_pos_y(he / 2 + 24);

    // MV.set_config_load_symbols(false);

    madnes.set_ico_size(214, 214 - 22);

    // madnes_show_money_anim_callback_timeout = 40;

    madnes_set_sprite("coins", 152, 152);

    madnes_set_sprite('_sprite', 214, 214);
    madnes_set_sprite('_blur', 214, 214);
    madnes_set_sprite('_burn', 214, 214);
    madnes_set_sprite('_wink', 214, 214);

    madnes_set_sprite('font_menu_Big', 40, 40);
    madnes_set_sprite('font_big-win', 134, 159);
    madnes_set_sprite('icon_Fire_Q', 200, 200);
    madnes_set_sprite('fire_question', 53, 70);
    madnes_set_sprite('icon_Win', 160, 160);

    madnes_set_sprite('bwanim', 730, 400);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced();
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            rof_infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function initLoad() {

}

export function game_start() {
    rof_rotate_run()
}

export function print_desk() {
    server_config.behavior = behavior_config
    rof_print_desk()
}

export function print_reels() {
    rof_print_reels();
}

export function infomenu_init() {
    rof_infomenu_init();
}

export function infomenu_open() {
    rof_infomenu_open();
}

export function infomenu_close() {
    rof_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {
    rof_infomenu_left();
}

export function infomenu_right() {
    rof_infomenu_right();
}

export function end_round_no_autostart() {
}

export function freespins_end_round(eventName, {ended}) {}

export function end_round_recalced() {
    devil_wink_eye_animation();
}

export function get_preinfo() {}

export function preinfo_close() {}